// extracted by mini-css-extract-plugin
module.exports = {"recommendedPodcastTile":"RecommendedPodcastTile_recommendedPodcastTile__zpXkd","image":"RecommendedPodcastTile_image___XMDV","title":"RecommendedPodcastTile_title__25VQl"};